var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoChatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 98,
    viewBox: "0 0 128 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 41.5,
    r: 37.5,
    fill: "#E7E0F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 9.5,
    r: 9.5,
    transform: "rotate(180 114.5 9.5)",
    fill: "#E7E0F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 85.5,
    r: 12.5,
    transform: "rotate(180 102.5 85.5)",
    fill: "#E7E0F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 47,
    r: 11,
    transform: "rotate(180 11 47)",
    fill: "#E7E0F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 24.5,
    r: 6.5,
    transform: "rotate(180 22.5 24.5)",
    fill: "#9A5DB8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 71.5,
    r: 6.5,
    transform: "rotate(180 22.5 71.5)",
    fill: "#9A5DB8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 17,
    width: 58,
    height: 16,
    rx: 4,
    fill: "#9A5DB8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 42.5,
    width: 50,
    height: 13,
    rx: 2.5,
    stroke: "#9A5DB8",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 62,
    width: 39,
    height: 16,
    rx: 4,
    fill: "#9A5DB8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChatsIcon);
export default __webpack_public_path__ + "static/media/no_chats_icon.d6c3f49410884d10dd7c63b71a90a817.svg";
export { ForwardRef as ReactComponent };